import { render, staticRenderFns } from "./HistoryFundsTableFilters.vue?vue&type=template&id=a94e8380&"
import script from "./HistoryFundsTableFilters.vue?vue&type=script&lang=ts&"
export * from "./HistoryFundsTableFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports